import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const changePassword = createAsyncThunk(
  "business/changePassword",
  async ({ userId, oldPassword, newPassword, token }, { rejectWithValue }) => {
    const baseUrl =
      process.env.REACT_APP_BACKEND_BASE_URL || "http://localhost:5000";

    try {
      console.log("🔐 Change Password API Call Started");

      const res = await axios.put(
        `${baseUrl}/business/update/${userId}/change-password`,
        { oldPassword, newPassword },
        {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        },
      );

      console.log("✅ Change Password Success:", res.data);

      return {
        message: res.data?.message || "Password changed successfully",
        success: true,
        data: res.data,
      };
    } catch (err) {
      console.log("❌ Change Password Error:", err);

      const status = err.response?.status;
      const message =
        err.response?.data?.message ||
        err.message ||
        "Server error. Please try again.";

      return rejectWithValue({
        message,
        status,
        success: false,
      });
    }
  },
);
